// import jQuery from 'CommonScripts/jquery-1.10.2'; 
/*
*   Accordion skeleton based on:
*   https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
*   Simplified and removed keyboard bindings
*/
(function (window, document, $) {

    $(document).ready(function () {
    Array.prototype.slice.call(document.querySelectorAll('.accordion__spot .accordion')).forEach(function (accordion) {
        // Create the array of toggle elements for the accordion group
        var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.accordion-trigger'));
        var panels = Array.prototype.slice.call(accordion.querySelectorAll('.accordion-panel'));

        // Check if it is desktop and use the height of the first panel
        if (window.innerWidth >= 768) {
            //Show the first panel by default
            panels[0].removeAttribute('hidden');
            triggers[0].setAttribute('aria-expanded', 'true');
            // add the height of the first panel to the accordion container
            accordion.style.height = panels[0].offsetHeight + 'px';
            
        }
        window.addEventListener('resize', function () {
            if (window.innerWidth >= 768) {
                accordion.style.height = panels[0].offsetHeight + 'px';
            } else {
                accordion.style.height = "";
            }
        });
        accordion.addEventListener('click', function (event) {
            var target = event.target;

            if (target.classList.contains('accordion-trigger')) {
                // Check if the current toggle is expanded.
                var isExpanded = target.getAttribute('aria-expanded') == 'true';
                var active = accordion.querySelector('[aria-expanded="true"]');
                var activePanelId = target.getAttribute('aria-controls');
                var activePanel = document.getElementById(activePanelId);
                //GTM
                window.dataLayer.push({
                    'event': 'interactionevent',
                    'eventcategory': 'Accordion',
                    'eventaction': 'click',
                    'eventlabel': $(target).find('.accordion-title').text().replace(/\n|\r/g, "").trim()
                });

                // without allowMultiple, close the open accordion
                if (active && active !== target) {
                    // Set the expanded state on the triggering element
                    active.setAttribute('aria-expanded', 'false');
                    // Hide the accordion sections, using aria-controls to specify the desired section
                    document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');
                }

                if (!isExpanded) {
                    // Set the expanded state on the triggering element
                    target.setAttribute('aria-expanded', 'true');
                    // Hide the accordion sections, using aria-controls to specify the desired section
                    document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

                    if (window.innerWidth >= 768) {
                        accordion.style.height = activePanel.offsetHeight + 'px';
                    }
                    window.addEventListener('resize', function () {
                        if (window.innerWidth >= 768) {
                            accordion.style.height = activePanel.offsetHeight + 'px';
                        } else {
                            accordion.style.height = "";
                        }
                    });
                }
                event.preventDefault();
            }
        });
    });
});

}) (window, document, jQuery);
